import { FC, useState } from 'react'
import { Alert, Button } from 'react-bootstrap'
import { Dialog } from 'primereact/dialog'
import { RefreshApiKeyDialogProps } from '../APIManager.d'
import { useAppSelector } from '../../../../../store/hooks'
import { useToast } from '../../../../common/toast/hooks/useToast'
import { api } from '../../../../../auth'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCircleNotch,
    faQuestionCircle,
    faRefresh,
} from '@fortawesome/free-solid-svg-icons'

const RefreshApiKeyDialog: FC<RefreshApiKeyDialogProps> = ({ setApiKey }) => {
    const theme = useAppSelector((state) => state.theme.theme)

    const [dialogVisible, setDialogVisible] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const { triggerToast } = useToast()
    const axiosPrivate = api

    const refreshApiKey = async () => {
        setIsSubmitting(true)

        try {
            const response = await axiosPrivate
                .post('/administration/refresh-api-key')
                .finally(() => {
                    setIsSubmitting(false)
                })
            if (response.data?.success === true) {
                triggerToast({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Your API key has been refresh successfully',
                })
                setDialogVisible(false)
                setApiKey(response.data?.data.api_key)
            } else {
                triggerToast({
                    severity: 'error',
                    summary: 'Failed',
                    detail:
                        response.data?.errors.join('. ') +
                        ' - Please try again!',
                })
            }
        } catch (err: any) {
            let errorMsg = ''
            // TODO: Sort out error handling!
            if (!err?.response) {
                errorMsg = 'No Server Response'
            } else {
                errorMsg = 'Refresh Failed'
            }

            triggerToast({
                severity: 'error',
                summary: 'Failed',
                detail: errorMsg + ' - Please try again!',
            })
        }
    }

    const footerContent = (
        <div>
            <Button
                variant={theme === 'dark' ? 'dark' : 'light'}
                onClick={() => setDialogVisible(false)}
                className="p-button-text"
            >
                No
            </Button>
            <Button variant="danger" onClick={refreshApiKey}>
                <span className="text-white">
                    {isSubmitting ? (
                        <>
                            <FontAwesomeIcon icon={faCircleNotch} spin={true} />{' '}
                            Refreshing...
                        </>
                    ) : (
                        'Yes'
                    )}{' '}
                </span>
            </Button>
        </div>
    )

    return (
        <>
            <Button
                variant="outline-danger"
                onClick={() => setDialogVisible(true)}
            >
                <FontAwesomeIcon icon={faRefresh} className="me-2" />
                <span>Refresh</span>
            </Button>
            <Dialog
                header={
                    <span>
                        <FontAwesomeIcon icon={faQuestionCircle} /> Confirm?
                    </span>
                }
                visible={dialogVisible}
                breakpoints={{ '960px': '60vw', '640px': '80vw' }}
                style={{ width: '35vw' }}
                onHide={() => setDialogVisible(false)}
                footer={footerContent}
                closable={false}
            >
                <>
                    <p className="mb-3 pb-3 border-bottom">
                        Are you sure you want to refresh the current API key?
                    </p>
                    <Alert variant="warning" className="border-0">
                        <strong>Warning!</strong>
                        <ul>
                            <li>
                                This key will be replaced by a new key
                                permenantly!
                            </li>
                            <li>
                                All APIs using this key will stop working until
                                the new key has been updated.
                            </li>
                        </ul>
                    </Alert>
                </>
            </Dialog>
        </>
    )
}

export default RefreshApiKeyDialog
